import script from "./ResetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPassword.vue?vue&type=script&setup=true&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=5915947c&lang=scss&scoped=true"

import exportComponent from "/builds/p3839/client-suite/proxima_blue2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5915947c"]])

export default __exports__